import notify from "devextreme/ui/notify";
import { useRef, useState } from "react";
import { useSelector } from "react-redux"
import { useParams } from "react-router-dom";
import { DataGrid, Modal } from "../../../../../components";
import { DataGridButtonProps, GridButtonType } from "../../../../../components/data-grid/types";
import { getApiParams } from "../../../../../redux/auth";
import { BodyType, createRequest } from "../../../../../redux/base/request";
import { ApiResponse, verfiyResponse } from "../../../../../redux/base/types/saga";
import { getLocalized } from "../../../../../redux/localization"
import { CreateAccountStorageForm } from "./create";
import { AccountStorageDetail } from "./detail";
import { EditAccountStorageForm } from "./edit";
import { AdminAccountLocation, CreateStorage, UpdateStorage } from "./type";

export const AccountStoragePage = ({ data }: { data?: AdminAccountLocation[] }) => {
    const { Id }: { Id: string } = useParams();
    const localize = useSelector(getLocalized);
    const [show, setShow] = useState(false)
    const [show1, setShow1] = useState(false)
    const { token, lang } = useSelector(getApiParams);
    const ref = useRef<any>();
    const ref1 = useRef<any>();
    const StorageData = useRef<AdminAccountLocation>({
        AccountId: "",
        AccountName: "",
        AddressDetail: "",
        City: "",
        CityId: "",
        Country: "",
        CountryId: "",
        Default: false,
        District: "",
        DistrictId: "",
        Id: "",
        Invoice: false,
        Latitude: null,
        LocationTitle: null,
        Longitude: null,
        Neighbourhood: "",
        NeighbourhoodId: "",
        SubDistrict: "",
        SubDistrictId: ""
    })
    const updateLocationData = useRef<UpdateStorage>({
        AccountId: "",
        AddressDetail: "",
        Default: false,
        Id: "",
        Invoice: true,
        Latitude: "",
        LocationTitle: "",
        Longitude: "",
        NeighbourhoodId: "",


    })
    const LocationData = useRef<CreateStorage>({
        accountId: "",
        addressDetail: "",
        default: true,
        invoice: true,
        latitude: "",
        locationTitle: "",
        longitude: "",
        neighbourhoodId: ""
    })
    const columns = [
        {
            dataField: "Country",
            caption: localize.getString("country")
        },
        {
            dataField: "City",
            caption: localize.getString("city")
        },
        {
            dataField: "District",
            caption: localize.getString("district")
        },
        {
            dataField: "SubDistrict",
            caption: localize.getString("subdistrict")
        },
        {
            dataField: "Neighbourhood",
            caption: localize.getString("neighbourhood")
        },
        {
            dataField: "AddressDetail",
            caption: localize.getString("addressDetail")
        },

    ]

    const buttons: GridButtonType[] = [
        {
            buttonText: "Yeni",
            icon: "add",
            type: "success",
            onclick: () => {
                setShow(true)
            }
        }
    ]
    const buttons1: DataGridButtonProps[] = [
        {

            icon: "edit",
            hint: "Edit",
            onClick: (async (e: any) => {
                console.log(e.row.data)
                updateLocationData.current.AccountId = Id;
                updateLocationData.current.Id = e.row.data.Id
                updateLocationData.current.AddressDetail = e.row.data.AddressDetail;
                updateLocationData.current.NeighbourhoodId = e.row.data.NeighbourhoodId;
                updateLocationData.current.LocationTitle = e.row.data.LocationTitle
                updateLocationData.current.Latitude = "27"
                updateLocationData.current.Longitude = "34"

                setShow1(true)
            })
        }
    ]
    return <>
        <Modal
            visible={show1}
            onHiding={() => { setShow1(false) }}
            title={localize.getString("editLocation")}
            width="40%"
            height="60%"

            onSubmitClick={async () => {
                updateLocationData.current.AccountId = Id;
                console.log(updateLocationData.current)

                const response: ApiResponse<UpdateStorage> = await createRequest({
                    method: "PUT",
                    url: "/api/admin/adminaccountstorages/" + updateLocationData.current.Id,
                    bodyType: BodyType.formdata,
                    token,
                    body: updateLocationData.current,
                    lang,
                });
                if (verfiyResponse(response)) {
                    notify(response.Message, "success")
                    ref1.current.instance.resetValues();
                    setShow1(false)
                } else {
                    notify(response.Message, "warning")
                }

            }}>
            <EditAccountStorageForm data={updateLocationData.current} data1={StorageData.current} ref={ref1}></EditAccountStorageForm>
        </Modal>
        <Modal
            visible={show}
            onHiding={() => { setShow(false) }}
            title={localize.getString("createLocation")}
            width="40%"
            height="60%"
            onSubmitClick={async () => {
                LocationData.current.accountId = Id;
                console.log(LocationData.current)
                const response: ApiResponse<CreateStorage> = await createRequest({
                    method: "POST",
                    url: "/api/admin/adminaccountstorages",
                    bodyType: BodyType.raw,
                    token,
                    body: LocationData.current,
                    lang,
                });
                if (verfiyResponse(response)) {
                    notify(response.Message, "success")
                    setShow(false)

                    ref.current.instance.resetValues();
                    setShow(false)
                } else {
                    notify(response.Message, "warning")
                }

            }}>
            <CreateAccountStorageForm data={LocationData.current} data1={StorageData.current} ref={ref}></CreateAccountStorageForm>
        </Modal>
        <DataGrid

            url={"/api/admin/adminaccountstorages/get-by-account-id?accountId=" + Id}
            getByIdUrl={"/api/admin/adminaccountstorages"}
            columns={columns}
            refObject={{}}
            gridButtons={buttons}
            buttons={buttons1}
            title="Adresler"
            details={{
                width: "30%",
                height: "50%",
                getByIdUrl: "/api/admin/adminaccountstorages",
                title: localize.getString("addressDetail"),
                component: AccountStorageDetail,
            }}
            // create={{
            //     width: "45%",
            //     height: "72%",
            //     createUrl: "/api/admin/adminaccountstorages",
            //     title: localize.getString("createLocation"),
            //     component: createAccountStorageForm,

            // }}
            remove={{
                url: "/api/admin/adminaccountstorages"
            }}
        />
    </>
}